import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetIssueUpdateByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useIsFeatureVisibleToOrg } from 'src/utils/featureFlags';

import { useGetIssueUpdateByIdTRPC } from './useGetIssueUpdateByIdTRPC';

export const useGetIssueUpdateById = (id?: string, skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  if (!id && !skip) {
    throw new Error('Issue Update ID is required unless skip is true');
  }

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetIssueUpdateByIdDocument, {
    variables: {
      _eq: id!, // Non-null assertion since we check for id above
    },
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetIssueUpdateByIdTRPC(id, skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
